import { AxiosError } from "axios";
import { ApiDisaster } from "../../../api/api";
import { GeneralInterface } from "../../../helpers/interfaces/general.interface";
import { EventTypeResultInterface } from "../interfaces/event-type-result.interface";
import { EventTypeSingleResultInterface } from "../interfaces/event-type-single-result.interface";

export interface EventTypeParam {
  size: number;
  page: number;
}

export const GetEventTypes = async (param: EventTypeParam): Promise<EventTypeResultInterface> => {
  try {
    const result = await ApiDisaster.get("/event-types", {
      params: {
        size: param.size,
        page: param.page
      }
    });
    return result.data as EventTypeResultInterface;
  } catch (e) {
    const error = e as AxiosError;
    return error.response?.data as GeneralInterface;
  }
};

export const ShowEventType = async (id: string): Promise<EventTypeSingleResultInterface> => {
  try {
    let response = await ApiDisaster.get(
      '/event-types/' + id,
    );
    return response.data as EventTypeSingleResultInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: EventTypeSingleResultInterface = a.response?.data;
    return response;
  }
}

export const SubmitEventType = async (form: any): Promise<EventTypeSingleResultInterface> => {
  try {
    let response = await ApiDisaster.post(
      '/event-types',
      form
    );
    return response.data as EventTypeSingleResultInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: EventTypeSingleResultInterface = a.response?.data;
    return response;
  }
}

export const UpdateEventType = async (id: string, form: any): Promise<EventTypeSingleResultInterface> => {
  try {
    let response = await ApiDisaster.put(
      '/event-types/' + id,
      form
    );
    return response.data as EventTypeSingleResultInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: EventTypeSingleResultInterface = a.response?.data;
    return response;
  }
}

export const DeleteEventType = async (id: string): Promise<GeneralInterface> => {
  try {
    let response = await ApiDisaster.delete(
      '/event-types/' + id
    );
    return response.data as GeneralInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: GeneralInterface = a.response?.data;
    return response;
  }
}